<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="11.667"
    height="15"
    viewBox="0 0 11.667 15"
  >
    <path
      d="M10.833,14.667a5,5,0,0,0,5-5V3H13.75V9.667a2.917,2.917,0,1,1-5.833,0V3H5.833V9.667A5,5,0,0,0,10.833,14.667ZM5,16.333V18H16.667V16.333Z"
      transform="translate(-5 -3)"
    />
  </svg>
</template>

<script>
export default {
  name: 'UnderlineIcon',
};
</script>
